assert = require 'app/scripts/lib/assert'
WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
t = require('app/scripts/views/internal/teacup-with-helpers')()
f = require 'effing'
trackEvent = require('@trello/analytics').track
locales = require('@trello/locale').supportedLocales
_ = require 'underscore'
bannerLocale = require('locale').banners
babble = require 'app/scripts/lib/babble'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

track = f(trackEvent, 'Header', 'New Locale Banner')

module.exports = class NewLocaleBannerView extends WarningBannerView
  initialize: ({ @locale }) ->
    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

  events:
    'click .js-switch-language': ->
      track("Set locale to #{@locale}")
      if @sendGASEvent
        Analytics.sendTrackEvent
          action: 'set'
          actionSubject: 'locale'
          source: 'newLocaleBanner'
          attributes:
            newLocale: @locale
      @setLocale()
    'click .js-dismiss': ->
      track("Dismiss #{@locale}")
      if @sendGASEvent
        Analytics.sendUIEvent
          action: 'dismissed'
          actionSubject: 'banner'
          source: 'newLocaleBanner'
          attributes:
            newLocale: @locale
      @dismiss(->)

  setLocale: ->
    @model.setPref 'locale', @locale, =>
      @dismiss =>
        document.location.reload()

  dismiss: (next) ->
    @model.dismissLanguageBannerFor @locale, =>
      @remove()
      next()

  render: ->
    # We have to translate the locale from a browser locale to a transifex
    # locale.
    translationsLocale = @locale.replace /-/, "_"
    data = bannerLocale[@locale] ? bannerLocale[translationsLocale] ? bannerLocale[translationsLocale.substr(0, translationsLocale.indexOf('_'))]
    assert data?, "Attempt to show a NewLocaleBanner with an unrecognized locale"
    language = _.find(locales, (locale) => locale.code == @locale)
    assert language?, "Attempt to show a NewLocaleBanner with an unrecognized language"

    if @sendGASEvent
      Analytics.sendScreenEvent
        name: 'newLocaleBanner'
        attributes:
          newLocale: @locale

    @$el.html t.render ->
      t.text  data.mainText.replace "{language}", language.name
      t.text ' '
      t.a { href: '#', class: 'quiet primary js-switch-language' }, data.switchText
      t.text ' - '
      t.a { href: '#', class: 'quiet js-dismiss' }, data.dismissText
    @
